import { Badge } from '@/components/ui/Badge'
import { GRADE_LABEL, type Grade, type SourceSummary } from '@/types/material'

const TONE: Record<Grade, 'default' | 'brand' | 'ok' | 'warn' | 'danger'> = {
  L0: 'ok',
  L1: 'ok',
  L2: 'brand',
  L3: 'warn',
  L4: 'danger',
}

export function SourceList({ sources }: { sources: SourceSummary[] }) {
  if (sources.length === 0) {
    return <p className="px-3 py-4 text-xs text-muted">未取到任何来源：结论只能是"无法判定"，请先补料</p>
  }

  return (
    <ul className="flex flex-col divide-y divide-line/70">
      {sources.map((source) => (
        <li key={source.id} className="px-3 py-2">
          <div className="flex flex-wrap items-center gap-1.5">
            <Badge tone={TONE[source.grade]}>{GRADE_LABEL[source.grade]}</Badge>
            <a
              href={source.url}
              target="_blank"
              rel="noreferrer"
              className="min-w-0 truncate text-[13px] font-medium text-brand-700 hover:underline"
            >
              {source.title}
            </a>
            <Badge tone={source.modelAnchored ? 'ok' : 'default'}>
              {source.modelAnchored ? '型号已锚定' : '未锚定本型号'}
            </Badge>
            {source.isRepostOf && <Badge tone="warn">转载并入 {source.isRepostOf}</Badge>}
          </div>
          <p className="mt-1 truncate text-[11px] text-muted">
            {source.siteName} · 独立分组 {source.independentGroup}
            {source.matchedQueries.length > 0 && ` · 命中查询 ${source.matchedQueries.length} 条`}
          </p>
        </li>
      ))}
    </ul>
  )
}
